// extracted by mini-css-extract-plugin
export default {"mainBlock":"style_mainBlock__kDyUq","image":"style_image__mgB5K","descriptionText":"style_descriptionText__4WUVB","description":"style_description__uPQZq"};